import apiSponsorPathConstants from "../../constants/organizer/sponsor-path.constant";
import axios from "../../configs/axios-instances";

const sponsorApi = {
  // ---------------- SPONSOR APIS ---------------- //
  listAvailableSponsors: ({ campaignId, params, success, error, final }) => {
    const {
      organizerSponsor: { getAllSponsors },
    } = apiSponsorPathConstants;
    const path = getAllSponsors.replace(":campaignId", campaignId);
    axios.getRequest({ path, params, success, error, final });
  },

  getUpcomingEvents: ({ params, success, error }) => {
    const {
      organizerSponsor: { getUpcomingEvents },
    } = apiSponsorPathConstants;
    axios.getRequest({ path: getUpcomingEvents, params, success, error });
  },

  getUpcomingMovies: ({ params, success, error }) => {
    const {
      organizerSponsor: { getUpcomingMovies },
    } = apiSponsorPathConstants;
    axios.getRequest({ path: getUpcomingMovies, params, success, error });
  },

  // ---------------- COMMITMENTS ---------------- //
  createCommitment: ({ payload, success, error }) => {
    const {
      commitments: { createCommitment },
    } = apiSponsorPathConstants;
    axios.postRequest({ path: createCommitment, payload, success, error });
  },

  getCommitments: ({ params, success, error }) => {
    const {
      commitments: { getCommitments },
    } = apiSponsorPathConstants;
    axios.getRequest({ path: getCommitments, params, success, error });
  },

  getCommitmentById: ({ id, success, error }) => {
    const {
      commitments: { getCommitmentById },
    } = apiSponsorPathConstants;
    const path = getCommitmentById.replace(":id", id);
    axios.getRequest({ path, success, error });
  },

  cancelCommitment: ({ id, success, error }) => {
    const {
      commitments: { deleteCommitment },
    } = apiSponsorPathConstants;
    const path = deleteCommitment.replace(":id", id);
    axios.deleteRequest({ path, success, error });
  },

  getCampaignFeeRules: (campaign_id, success, error, final) => {
    const {
      campaigns: { feeRules },
    } = apiSponsorPathConstants;

    const path = feeRules(campaign_id);
    axios.getRequest({
      path,
      success,
      error,
      final,
    });
  },
  // ---------------- DELIVERABLES ---------------- //
  createDeliverable: ({ id, payload, success, error }) => {
    const {
      deliverables: { createDeliverables },
    } = apiSponsorPathConstants;
    const path = createDeliverables.replace(":id", id);
    axios.postRequest({ path, payload, success, error });
  },

  updateDeliverable: ({ id, did, payload, success, error }) => {
    const {
      deliverables: { updateDeliverablesById },
    } = apiSponsorPathConstants;
    let path = updateDeliverablesById.replace(":id", id).replace(":did", did);
    axios.patchRequest({ path, payload, success, error });
  },

  editDeliverable: ({ id, did, payload, success, error }) => {
    const {
      deliverables: { editDeliverable },
    } = apiSponsorPathConstants;
    let path = editDeliverable.replace(":id", id).replace(":did", did);
    axios.patchRequest({ path, payload, success, error });
  },

  getMyDeliverables: ({ params, success, error }) => {
    const {
      deliverables: { getMyDeliverables },
    } = apiSponsorPathConstants;
    axios.getRequest({ path: getMyDeliverables, params, success, error });
  },

  getSponsorDeliverables: ({ id, success, error }) => {
    const {
      deliverables: { getSponsorDeliverablesById },
    } = apiSponsorPathConstants;
    const path = getSponsorDeliverablesById.replace(":id", id);
    axios.getRequest({ path, success, error });
  },

  reviewDeliverable: ({ id, did, payload, success, error }) => {
    const {
      deliverables: { reviewDeliverable },
    } = apiSponsorPathConstants;
    const path = reviewDeliverable.replace(":id", id).replace(":did", did);
    axios.patchRequest({ path, payload, success, error });
  },

  // ---------------- PITCHES ---------------- //
  createPitch: ({ payload, success, error }) => {
    const {
      pitches: { createPitch },
    } = apiSponsorPathConstants;
    axios.postRequest({ path: createPitch, payload, success, error });
  },

  listMyPitches: ({ params, success, error }) => {
    const {
      pitches: { listMyPitches },
    } = apiSponsorPathConstants;
    axios.getRequest({ path: listMyPitches, params, success, error });
  },

  getPitchById: ({ id, success, error }) => {
    const {
      pitches: { getPitchById },
    } = apiSponsorPathConstants;
    const path = getPitchById.replace(":id", id);
    axios.getRequest({ path, success, error });
  },

  editPitch: ({ id, payload, success, error }) => {
    const {
      pitches: { editPitch },
    } = apiSponsorPathConstants;
    const path = editPitch.replace(":id", id);
    axios.patchRequest({ path, payload, success, error });
  },

  deletePitch: ({ id, success, error }) => {
    const {
      pitches: { deletePitch },
    } = apiSponsorPathConstants;
    const path = deletePitch.replace(":id", id);
    axios.deleteRequest({ path, success, error });
  },

  // ---------------- CAMPAIGNS ---------------- //
  createCampaign: ({ payload, success, error }) => {
    const {
      campaigns: { createCampaign },
    } = apiSponsorPathConstants;
    axios.postRequest({ path: createCampaign, payload, success, error });
  },
  getAllCampaigns: ({ params, success, error, final }) => {
    const {
      campaigns: { getAllCampaigns },
    } = apiSponsorPathConstants;
    axios.getRequest({ path: getAllCampaigns, params, success, error, final });
  },
  getCampaignById: ({ campaignId, success, error, final }) => {
    const {
      campaigns: { getCampaignById },
    } = apiSponsorPathConstants;
    const path = getCampaignById.replace(":campaignId", campaignId);
    axios.getRequest({ path, success, error, final });
  },

  updateCampaign: ({ campaignId, payload, success, error, final }) => {
    const {
      campaigns: { updateCampaign },
    } = apiSponsorPathConstants;
    const path = updateCampaign.replace(":campaignId", campaignId);
    axios.patchRequest({ path, payload, success, error, final });
  },
  deleteCampaign: ({ campaignId, success, error, final }) => {
    const {
      campaigns: { deleteCampaign },
    } = apiSponsorPathConstants;
    const path = deleteCampaign.replace(":campaignId", campaignId);
    axios.deleteRequest({
      path,
      success,
      error,
      final,
    });
  },

  // ---------------- CAMPAIGN REQUESTS ---------------- //
  getAllCampaignRequests: ({ params, success, error, final }) => {
    const {
      campaigns: { getAllCampaignRequests },
    } = apiSponsorPathConstants;
    axios.getRequest({
      path: getAllCampaignRequests,
      params,
      success,
      error,
      final,
    });
  },
  getCampaignRequests: ({ campaignId, params, success, error, final }) => {
    const {
      campaigns: { getCampaignRequests },
    } = apiSponsorPathConstants;
    const path = getCampaignRequests.replace(":campaignId", campaignId);
    axios.getRequest({ path, params, success, error, final });
  },

  getCampaignRequestById: ({
    campaignId,
    requestId,
    success,
    error,
    final,
  }) => {
    const {
      campaigns: { getCampaignRequestById },
    } = apiSponsorPathConstants;
    const path = getCampaignRequestById
      .replace(":campaignId", campaignId)
      .replace(":requestId", requestId);
    axios.getRequest({ path, success, error, final });
  },

  acceptRequest: ({
    campaignId,
    requestId,
    payload,
    success,
    error,
    final,
  }) => {
    const {
      campaigns: { AcceptRequest },
    } = apiSponsorPathConstants;
    const path = AcceptRequest.replace(":campaignId", campaignId).replace(
      ":requestId",
      requestId
    );
    axios.patchRequest({ path, payload, success, error, final });
  },

  rejectRequest: ({ campaignId, requestId, success, error, final }) => {
    const {
      campaigns: { rejectRequest },
    } = apiSponsorPathConstants;
    const path = rejectRequest
      .replace(":campaignId", campaignId)
      .replace(":requestId", requestId);
    axios.patchRequest({ path, success, error, final });
  },

  changeRequest: ({
    campaignId,
    requestId,
    payload,
    success,
    error,
    final,
  }) => {
    const {
      campaigns: { changeRequest },
    } = apiSponsorPathConstants;
    const path = changeRequest
      .replace(":campaignId", campaignId)
      .replace(":requestId", requestId);
    axios.patchRequest({ path, payload, success, error, final });
  },

  // ---------------- CAMPAIGN INVITES ---------------- //

  sendCampaignInvites: ({ campaignId, payload, success, error, final }) => {
    const {
      campaigns: { sendCampaignInvites },
    } = apiSponsorPathConstants;
    const path = sendCampaignInvites.replace(":campaignId", campaignId);
    axios.postRequest({
      path,
      payload,
      success,
      error,
      final,
    }); /* correct*/
  },

  listOutgoingInvites: ({ params, success, error, final }) => {
    const {
      campaigns: { getOutgoingInvites },
    } = apiSponsorPathConstants;

    axios.getRequest({
      path: getOutgoingInvites,
      params,
      success,
      error,
      final,
    });
  },

  cancelCampaignInvite: ({ campaignId, requestId, success, error, final }) => {
    const {
      campaigns: { deleteCampaignInvite },
    } = apiSponsorPathConstants;
    const path = deleteCampaignInvite
      .replace(":campaignId", Number(campaignId))
      .replace(":requestId", requestId);
    axios.deleteRequest({ path, success, error, final });
  },

  // ---------------- CAMPAIGN PACKAGES ---------------- //
  createCustomPack: ({ eventId, payload, success, error, final }) => {
    const {
      packages: { createCustomPack },
    } = apiSponsorPathConstants;
    const path = createCustomPack.replace(":eventId", eventId);
    axios.postRequest({ path, payload, success, error, final });
  },

  updateCustomPack: ({ eventId, packId, payload, success, error, final }) => {
    const {
      packages: { updateCustomPack },
    } = apiSponsorPathConstants;
    const path = updateCustomPack
      .replace(":eventId", eventId)
      .replace(":packId", packId);
    axios.patchRequest({ path, payload, success, error, final });
  },

  updateDefaultPack: ({ eventId, packId, payload, success, error, final }) => {
    const {
      packages: { updateDefaultPack },
    } = apiSponsorPathConstants;
    const path = updateDefaultPack
      .replace(":eventId", eventId)
      .replace(":packId", packId);
    axios.patchRequest({ path, payload, success, error, final });
  },

  deletePack: ({ packId, success, error, final }) => {
    const {
      packages: { deletePack },
    } = apiSponsorPathConstants;
    const path = deletePack.replace(":packId", packId);
    axios.deleteRequest({ path, success, error, final });
  },

  previewCalculatePack: ({ payload, success, error, final }) => {
    const {
      packages: { previewCalculatePack },
    } = apiSponsorPathConstants;

    axios.postRequest({
      path: previewCalculatePack,
      payload,
      success,
      error,
      final,
    });
  },

  benefitsList: ({ params, success, error, final }) => {
    const {
      packages: { benefitsList },
    } = apiSponsorPathConstants;

    axios.getRequest({
      path: benefitsList,
      params,
      success,
      error,
      final,
    });
  },

  getContract: ({ id, success, error, final }) => {
    const {
      contract: { getContract },
    } = apiSponsorPathConstants;
    const path = getContract(id);
    axios.getRequest({ path, success, error, final });
  },

  getPaymentStatus: ({ id, success, error, final }) => {
    const {
      payment: { getPaymentStatus },
    } = apiSponsorPathConstants;
    const path = getPaymentStatus(id);
    axios.getRequest({ path, success, error, final });
  },
};

export default sponsorApi;
